import { styled } from '@mui/material/styles';

export const Container = styled('div')(
    () => `
    @media (max-width: 1024px) {
        padding: 16px 16px 0 16px;
        height: calc(var(--100vh) - 108px);
    }
`,
);

export const PageGrid = styled('div', {
    shouldForwardProp: prop => prop !== 'contactIsOpen',
})(({ contactIsOpen }) => ({
    height: 'calc(var(--100vh) - 85px)',
    display: 'grid',
    gridTemplateColumns: contactIsOpen ? '360px calc(100% - 752px)' : '360px 1fr',
    transition: 'width 0.4s ease-in-out',
    gridTemplateRows: '1fr',
    gridGap: '0 16px',
    '@media (max-width: 1480px)': {
        gridTemplateColumns: contactIsOpen ? '270px calc(100% - 572px)' : '360px 1fr',
    },
    '@media (max-width: 1280px)': {
        gridTemplateColumns: contactIsOpen ? '200px calc(100% - 416px)' : '360px 1fr',
        gridGap: '0 8px',
    },
    '@media (max-width: 768px)': {
        height: '100%',
        gridTemplateColumns: '100%',
    },
}));
